
































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Banana extends Vue {
  private isSpeen = false
}
